import { CodeHighlightNode, CodeNode } from "@lexical/code-core";
import type { InitialConfigType } from "@lexical/react/LexicalComposer";
import editorTheme from "./themes/editorTheme.ts";

export const editorCodeConfig: InitialConfigType = {
	namespace: "",
	theme: editorTheme,
	onError(error) {
		throw error;
	},
	nodes: [
		CodeNode,
		CodeHighlightNode,
	]
};
